document.addEventListener("DOMContentLoaded", function () {
    let url = window.location.href;   
    if(url.indexOf('#cart') > -1) {
     // toggleCartDrawer();
     $('.header__icon--cart')[0].click()
      let newurl = String( document.location.href ).replace( /#cart/, "" );
      window.history.pushState({ path: newurl }, '', newurl);
    }   
   $('.quick-addToCart').on('click', function() {
      quickaddToCart('add');
     $('.quickview_modal').hide();
     $('.quickview_modal').removeClass('active'); 
    })  
    $('#addToCart').on('click', function() {
      addToCart('add');
    })    
    $('#buyNow').on('click', function() {
      addToCart('buy');
    }) 
  });
   //Add item to cart, or clear and add item then go straight to checkout
  function quickaddToCart(x) {
   console.log('test');
    if($('.quickview_modal.active .quick-productSelect option').length > 0){
      var variantId =  $('.quickview_modal.active .quick-productSelect option:selected').val();
    }
    let qty = $('.quickview_modal.active .form-hidden-qty-num').val();
    var sellingPlanId = null;
    if($('.quickview_modal.active .subsave-plan').hasClass('option-button-selected')){
        sellingPlanId = $('.quickview_modal.active .subscription-selector.option-button-selected').length > 0 ? $('.quickview_modal.active .subscription-selector.option-button-selected').attr('data-selling-plan-id') : null;
    }    
    let formData = {};
    let cartCleared = $.Deferred();
    let alreadyInCart = false;    
    toggleButtons(); 
    console.log(sellingPlanId)
    if (sellingPlanId == null) {
      bogoActive ? formData = {'items': [{ 'id': variantId, 'quantity': qty },{ 'id': variantId, 'quantity': qty, 'properties': { 'deal': 'BOGO' ,'Bundle & Save 10%':'true' ,'Bundle':'Bundle and Save Discount'} }] } : formData = {'items': [{ 'id': variantId, 'quantity': qty, 'properties': { 'Bundle & Save 10%':'true','Bundle':'Bundle and Save Discount'} }] } ;
    } else {
      bogoActive ? formData = {'items': [{ 'id': variantId, 'quantity': qty, 'selling_plan': sellingPlanId },{ 'id': variantId, 'quantity': qty, 'properties': { 'deal': 'BOGO','Bundle & Save 10%':'true','Bundle':'Bundle and Save & Subscription Discount' } }] } : formData = {'items': [{ 'id': variantId, 'quantity': qty, 'selling_plan': sellingPlanId , 'properties': { 'Bundle & Save 10%':'true','Bundle':'Bundle and Save & Subscription Discount'}}] } ;
    }
     if ( x == 'buy' ) {
      let clearCart = $.post('/cart/clear.js','',null,'json');          
      clearCart.done(function() {
        cartCleared.resolve();
      });        
    } else {
      cartCleared.resolve();      
      fetch('/cart.js')
      .then(response => { return response.json(); })
      .then(result => { 
        for(i=0; i < result.items.length; i++) {
          if(result.items[i].variant_id == variantId) {
            alreadyInCart = true;
          }
        }
      })
      .catch((error) => { console.error('Error:', error); });
    }    
    return $.when(cartCleared).done(function() {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => { return response.json(); })
      .then(result => { 
        console.log('Success:', result);
        if (x == 'add') { // window.location.href='#cart'; // location.reload();         
          $(".header__icon--cart").load(location.href + "  .header__icon--cart>*","");
          $("#CartDrawer").load(location.href + "  #CartDrawer>*","");
          $('cart-drawer').addClass('active');          
        } else {    
          loadingModal('Loading Checkout...');
        }
        toggleButtons();        
      })
      .catch((error) => { console.error('Error:', error); });
    }).promise();
  }
  //Add item to cart, or clear and add item then go straight to checkout
  function addToCart(x) {   
    if($('.product__info-container  #productSelect option').length > 0){
      var variantId =  $('.product__info-container  #productSelect option:selected').val();
    }else{
      var variantId =  $('.quickview_modal.active input[name="id"]').val();
    }
    let qty = $('.product__info-container  .form-hidden-qty-num').val();    
    var sellingPlanId = null;
    if($('.product__info-container li#subsave').hasClass('option-button-selected')){
        sellingPlanId = $('.product__info-container .subscription-selector.option-button-selected').length > 0 ? $('.product__info-container .subscription-selector.option-button-selected').attr('data-selling-plan-id') : null;
    }    
    let formData = {};
    let cartCleared = $.Deferred();
    let alreadyInCart = false;    
    toggleButtons();
    
    if (sellingPlanId == null) {
      bogoActive ? formData = {'items': [{ 'id': variantId, 'quantity': qty },{ 'id': variantId, 'quantity': qty, 'properties': { 'deal': 'BOGO' } }] } : formData = {'items': [{ 'id': variantId, 'quantity': qty }] } ;
    } else {
      bogoActive ? formData = {'items': [{ 'id': variantId, 'quantity': qty, 'selling_plan': sellingPlanId },{ 'id': variantId, 'quantity': qty, 'properties': { 'deal': 'BOGO' } }] } : formData = {'items': [{ 'id': variantId, 'quantity': qty, 'selling_plan': sellingPlanId }] } ;
    }  
    if ( x == 'buy' ) {
      let clearCart = $.post('/cart/clear.js','',null,'json');          
      clearCart.done(function() {
        cartCleared.resolve();
      });        
    } else {
      cartCleared.resolve();      
      fetch('/cart.js')
      .then(response => { return response.json(); })
      .then(result => { 
        for(i=0; i < result.items.length; i++) {
          if(result.items[i].variant_id == variantId) {
            alreadyInCart = true;
          }
        }
      })
      .catch((error) => { console.error('Error:', error); });
    }    
    return $.when(cartCleared).done(function() {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => { return response.json(); })
      .then(result => { 
        console.log('Success:', result);
        if (x == 'add') {
           window.location.href='#cart';
          location.reload();
          //  $(".header__icon--cart").load(location.href + "  .header__icon--cart>*","");
          // $("#CartDrawer").load(location.href + "  #CartDrawer>*","");
          // $('cart-drawer').addClass('active');  
         // $('.header__icon--cart')[0].click()
        } else {    
          loadingModal('Loading Checkout...');
        }
        toggleButtons();        
      })
      .catch((error) => { console.error('Error:', error); });
    }).promise();
  }  
  //disable and enable action buttons on pdp
  function toggleButtons() {
    let status;    
    $('#addToCart, #buyNow').prop('disabled') == false ? status = true : status = false;
    $('#addToCart, #buyNow').prop('disabled', status);
  }  
  //update desktop and mobile cart counters in header bar
  function updateCounter(x) {
    console.log('Counter updated: '+x);
    $('.cart-item-count').each(function() {
      console.log($(this).text());
      $(this).text(x);
    });
  }  
  //update cart subtotal
  function updateSubtotal(x) {
    console.log('Subtotal updated');
    let subtotal = '$' + parseFloat(x / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString();
    let sezzlePrice = '$' + parseFloat(( x / 4) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString();
    $('.subtotal p span.total').text(subtotal);
    $('#sezzleCartPrice').text(sezzlePrice);
  }  
  //update shipping quote and FREE shipping qualifier notice
  function updateShipping(x) {
    console.log('Shipping updated');
    if(x > 20000){
      console.log('Over $200');
      $('.cart-notice span').text('Your order qualifies for FREE Priority shipping!');
      $('.shipping .total').text('Free Priority Shipping');
    } else if(x > freeShipBase) {
      console.log('Over $69');
      toShipping = 20000 - x; 
      $('.cart-notice span').text('Your order qualifes for FREE Standard shipping. Add $'+ parseFloat(toShipping / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString() +' to get FREE Priority shipping!')
      $('.shipping .total').text('Free Standard Shipping');
    } else {
      console.log('Under $69');
      toShipping = freeShipBase - x; 
      $('.cart-notice span').text('Add $'+ parseFloat(toShipping / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString() +' to get FREE Standard shipping!')
      $('.shipping .total').text('Calculated at Checkout');
    }
  }  
  //update loyalty points earned
  function updateLoyalty(x) {
    let loyalty = $('.loyalty span.total');
    let multiplier = loyalty.attr('data-multiplier');    
    if( loyalty.attr('data-customer') == 'true' ) {
      console.log('Loyalty updated');
      let points = Math.floor(parseFloat(x / 100).toFixed(2)) * multiplier;
      loyalty.text(points);
    }
  }  
  //update line item where action was performed
  function updateLineItem(x,y) {
    console.log('Lineitem updated');
    let variantI = x.split(':');
    let item;    
    for(i=0; i < y.items.length; i++) {
      if(y.items[i].key == x) {
        item = y.items[i];  
      }
    }    
    //update final price
    $('.cart-item[data-id="'+x+'"]').find('.cart-item__price').text('$'+parseFloat(item.final_price / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString());
    //update compare price
    if( item.final_price < item.original_price ) {
      $('.cart-item[data-id="'+x+'"] .cart-item__price').append(`
        <u>$`+ parseFloat(item.original_price / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString() + `</u>
      `);
    }    
    //update quantity
    $('.cart-item[data-id="'+x+'"]').find('input').val(item.quantity);
    //update discount labels
    if(item.discounts.length > 0) {
      $('.cart-item[data-id="'+x+'"] .cart-item__order-discount').remove();
      for(i=0; i < item.discounts.length; i++) {
        let discount = item.discounts[i];
        $('.cart-item[data-id="'+x+'"] .cart-item__order-discounts').append(`
          <span class="cart-item__order-discount">
            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-saletag">
              <path d="M10 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0-3H7a1 1 0 0 0-.71.29l-6 6a1 1 0 0 0 0 1.42l4 4a1 1 0 0 0 1.42 0c.19-.2 5.8-5.81 6-6A1 1 0 0 0 12 5V2a2 2 0 0 0-2-2z" fill="{{ color }}"/>
            </svg>
              ` + discount.title +` ($-` + parseFloat(discount.amount / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString() + `)
          </span>
        `); 
      } 
    }
    else {
      $('.cart-item[data-id="'+x+'"] .cart-item__order-discount').remove();
    }    
    toggleLoadingModal('Cart Updated'); 
  }  
  //update cart after action
  function updateCart(x,y) {
    fetch('/cart.js')
    .then(response => { return response.json(); })
    .then(result => { 
      console.log('Success:', result.item_count);
      console.log('Success:', result);
      updateCounter(result.item_count);
      updateSubtotal(result.total_price);
      updateLoyalty(result.total_price);
      updateShipping(result.total_price);
      if(y == 1) {
        updateLineItem(x,result);
      } else {
        toggleLoadingModal('Cart Updated'); 
      }
    })
    .catch((error) => { 
      console.error('UpdateCart Error:', error); 
        window.location.href='#cart';
      location.reload();
    });
  }  
  //Adjust cart line item quantities
  function adjustQty(x,y,z) {
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(x)
    })
    .then(response => { return response.json(); })
    .then(result => { 
      //console.log('Cart updated:', result);  
      if(y == 0) {
        console.log('got here')
        bogoActive ? $('.cart-item[data-prod-id="'+z+'"]').slideUp('slow', function(){ $('.cart-item[data-prod-id="'+z+'"]').remove(); }) : $('.cart-item[data-id="'+z+'"]').slideUp('slow', function(){ $('.cart-item[data-id="'+z+'"]').remove(); });
        updateCart(z, 0);
      } else {
        updateCart(z, 1);
      }
    })
    .catch((error) => { 
      console.log('AdjustQty Error:', error); 
        //window.location.href='#cart';
      //location.reload();
    });
  }